module.exports = __webpack_public_path__ + "static/media/carPin.dbd65467.svg";